// The Windows source/protocol is absent. No guessed endpoints, private pixels or
// credentials are sent. Task 06 must verify LAN HTTPS/origin permissions, signed
// tickets/receipts and agent deduplication before a real adapter is registered.
export const shippingAgentGate = 'Physical Shipping printing is disabled until the Windows agent source and Brother hardware checks are completed.';
export async function dispatchShippingPrint() { throw new Error(shippingAgentGate); }
export async function reconcileShippingPrint() { throw new Error(shippingAgentGate); }
